
export default function isOldMiam() {
  // si le host contient www.miam-vercors.com renvoyer true
  return window.location.host.indexOf('www.miam-vercors.com') !== -1 || (window.location.host.indexOf('localhost:8098') !== -1);
}